"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = configureStore;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _reduxLogger = require("redux-logger");
var _redux = require("redux");
var _index = _interopRequireDefault(require("../reducers/index"));
var _handleResetOnAction = _interopRequireDefault(require("./handleResetOnAction"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isReactNative = (typeof navigator === "undefined" ? "undefined" : (0, _typeof2["default"])(navigator)) === 'object' && navigator.product === 'ReactNative';
var defaultStoreOptions = {
  middleware: [],
  enhancers: [],
  reducers: _index["default"],
  initialState: {},
  enableLogger: process.env.NODE_ENV !== 'production' && process.env.IS_BROWSER || isReactNative,
  resetOnAction: []
};
function configureStore() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var injectors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var pageProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // Injection point: beforeConfigureStore
  // Using the beforeConfigureStore, determine what the full storeOptions should be
  // by reducing each result of beforeConfigureStore with the previous
  var storeOptions = injectors.filter(function (injector) {
    return injector.beforeConfigureStore;
  }).reduce(function (prevOptions, injector) {
    return _objectSpread(_objectSpread({}, prevOptions), injector.beforeConfigureStore(prevOptions, pageProps));
  }, // Create the base storeOptions from the defaults and those defined by the platform
  _objectSpread(_objectSpread({}, defaultStoreOptions), options));

  // Logger must be the last middleware in chain.
  if (storeOptions.enableLogger) {
    storeOptions.middleware.push((0, _reduxLogger.createLogger)({
      collapsed: true,
      // Convert objects to pure javascript
      stateTransformer: function stateTransformer(state) {
        return JSON.parse(JSON.stringify(state));
      }
    }));
  }

  // Add middleware as the first enhancer
  storeOptions.enhancers.unshift(_redux.applyMiddleware.apply(void 0, (0, _toConsumableArray2["default"])(storeOptions.middleware)));

  // Always push reduxDevTools to the end of the enhancer stack
  // This is only active in development mode and in clients with the devtools installed
  // Redux tools extension https://github.com/zalmoxisus/redux-devtools-extension
  if (process.env.NODE_ENV !== 'production' && (typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === 'object' && typeof window.devToolsExtension === 'function') {
    storeOptions.enhancers.push(window.devToolsExtension());
  }

  // Combine reducers and create store
  var combinedReducer = (0, _redux.combineReducers)(storeOptions.reducers);
  var store = (0, _redux.createStore)((0, _handleResetOnAction["default"])(combinedReducer, storeOptions.initialState, storeOptions.resetOnAction), storeOptions.initialState, _redux.compose.apply(void 0, (0, _toConsumableArray2["default"])(storeOptions.enhancers)));

  // Injection point: afterConfigureStore
  injectors.filter(function (injector) {
    return injector.afterConfigureStore;
  }).forEach(function (injector) {
    return injector.afterConfigureStore(store, pageProps, storeOptions);
  });
  return store;
}
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/thunderball-client/lib/render/configureStore.js
// module id = 3056
// module chunks = 25